export default __webpack_public_path__ + "static/media/banner.f94fd494.jpg";